module.exports = __webpack_public_path__ + "static/media/epark-minus.9dd0ccac.svg";